import { gql } from '@apollo/client';

export default gql`
  fragment ImageFragment on Image {
    asset {
      metadata {
        blurHash
      }
      _id
    }
  }
`;
